/*
 * effects.ts — small tactile touches that are pure decoration.
 * Everything here is skipped entirely under prefers-reduced-motion; the foil
 * sheen and hover lifts are declarative in site.css.
 */

export function initEffects(): void {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  document.querySelectorAll<HTMLElement>(".btn-wf").forEach((btn) => {
    btn.addEventListener("click", (ev) => {
      const rect = btn.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const ripple = document.createElement("span");
      ripple.className = "btn-wf__ripple";
      ripple.style.width = `${size}px`;
      ripple.style.height = `${size}px`;
      ripple.style.left = `${ev.clientX - rect.left - size / 2}px`;
      ripple.style.top = `${ev.clientY - rect.top - size / 2}px`;
      btn.appendChild(ripple);
      ripple.addEventListener("animationend", () => ripple.remove());
    });
  });
}
